// extracted by mini-css-extract-plugin
module.exports = {"title":"PaymentMethod_title__17eS7","methodSpacing":"PaymentMethod_methodSpacing__3ks07","root":"PaymentMethod_root__19yyh"};